<template>
  <form @submit.prevent="submitted">
    <div class="form-group">
      <text-field
        id="name"
        label="Name"
        placeholder="Name of the business rule."
        v-model="v$.name.$model"
      >
        <template v-slot:validation v-if="v$.name.$error">
          <validation-error v-if="!v$.name.required"
            >You must specify a name for the rule.</validation-error
          >
        </template>
      </text-field>
      <expression-editor
        v-model="expression"
        @validate="
          (valid) => {
            expressionValid = valid;
          }
        "
      ></expression-editor>
      <form-buttons>
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="!submitEnabled"
        >
          {{ editing ? "Save" : "Create" }}
        </button>
        <button type="button" class="btn btn-secondary" @click="cancelClicked">
          Cancel
        </button>
      </form-buttons>
    </div>
  </form>
</template>
<script>
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { newGuid } from "@/util/guid";
import documentModelMixin from "@/mixins/documentModel";
import ValidationError from "@/components/common/forms/ValidationError.vue";
import ExpressionEditor from "@/components/business-rules/ExpressionEditor.vue";

const cancelClicked = function() {
  this.$emit("cancel");
};

const submitted = async function() {
  this.v$.$touch();

  if (this.v$.$invalid) {
    this.submitStatus = "ERROR";
  } else{
    this.submitStatus = "PENDING";

    this.logDebug("Saving display rule.");

    const model = this.documentModel;

    let rule = model.businessRules.find((r) => r.id === this.id);

    if (rule) {
      rule.name = this.name;
      rule.expression = this.expression;
      this.logDebug("Rule already exists.  Updated existing rule.", { rule });
    } else {
      rule = {
        id: this.id,
        name: this.name,
        expression: this.expression,
      };

      model.businessRules.push(rule);
      this.logDebug("Added new display rule", { rule });
    }

    await this.saveDocumentModel(model);
    this.logDebug("Document model saved.", model);
    this.$emit("save", rule);
  }
};

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  components: { ValidationError, ExpressionEditor },
  mixins: [documentModelMixin],
  props: {
    rule: {
      required: false,
    },
  },
  data: function() {
    return {
      id: newGuid(),
      name: "",
      expression: "",
      expressionValid: false,
    };
  },
  computed: {
    editing: function() {
      return !!this.rule;
    },
    submitEnabled: function() {
      return !this.v$.$invalid && this.expressionValid;
    },
  },
  validations() {
    return {
      name: {
        required,
      },
    };
  },
  methods: {
    submitted,
    cancelClicked,
  },
  emits: ["save", "cancel"],
  mounted: function() {
    const rule = this.rule;
    if (rule) {
      this.id = rule.id;
      this.name = rule.name;
      this.expression = rule.expression;
    }
  },
};
</script>
